import {
  PackageBuyConfirmationModalController,
  PackageBuyConfirmationModalTemplate,
} from '../../blocks/modals/PackageBuyConfirmationModal';
import {
  PackageBuyResultModalController,
  PackageBuyResultModalTemplate,
} from '../../blocks/modals/PackageBuyResultModal';

import { OPEN_MODAL } from '../../../../shared/actions/modal';
import activeDraftCtrl from '../../blocks/modals/modal-active-draft/modal-active-draft.controller';
import activeDraftTemplate from '../../blocks/modals/modal-active-draft/modal-active-draft.jade';
import adAssessmentTemplate from '../../blocks/modals/modal-ad-assessment/modal-ad-assessment.jade';
import advertiseObjectCtrl from '../../blocks/modals/modal-advertise-object/advertise-object.controller';
import advertiseObjectTemplate from '../../blocks/modals/modal-advertise-object/advertise-object.jade';
import app from '../app';
import auctionAddCtrl from '../../blocks/modals/modal-auction-add/modal-auction-add.controller';
import auctionAddTemplate from '../../blocks/modals/modal-auction-add/modal-auction-add.jade';
import auctionConfirmCtrl from '../../blocks/modals/modal-auction-confirm/modal-auction-confirm.controller';
import auctionConfirmTemplate from '../../blocks/modals/modal-auction-confirm/modal-auction-confirm.jade';
import auctionIncreaseCtrl from '../../blocks/modals/modal-auction-increase/modal-auction-increase.controller';
import auctionIncreaseTemplate from '../../blocks/modals/modal-auction-increase/modal-auction-increase.jade';
import authErrorCtrl from '../../blocks/modals/modal-auth-error/modal-auth-error.controller';
import authErrorTemplate from '../../blocks/modals/modal-auth-error/modal-auth-error.jade';
import fullscreenPlanPreviewCtrl from '../../blocks/modals/modal-fullscreen-plan-preview/modal-fullscreen-plan-preview.controller';
import fullscreenPlanPreviewTemplate from '../../blocks/modals/modal-fullscreen-plan-preview/modal-fullscreen-plan-preview.jade';
import homeownerHintTemplate from '../../blocks/modals/modal-homeowner-hint/modal-homeowner-hint.jade';
import identificationCtrl from '../../blocks/modals/modal-identification/modal-identification.controller';
import identificationErrorCtrl from '../../blocks/modals/modal-identification-error/modal-identification-error.controller';
import identificationErrorTemplate from '../../blocks/modals/modal-identification-error/modal-identification-error.jade';
import identificationTemplate from '../../blocks/modals/modal-identification/modal-identification.jade';
import ivrRemindCtrl from '../../blocks/modals/modal-ivr-remind/modal-ivr-remind.controller';
import ivrRemindTemplate from '../../blocks/modals/modal-ivr-remind/modal-ivr-remind.jade';
import jkAddCtrl from '../../blocks/modals/modal-jk-add/modal-jk-add.controller';
import jkAddTemplate from '../../blocks/modals/modal-jk-add/modal-jk-add.jade';
/* eslint-disable max-lines */
import { listenEvent } from '../../../../shared/utils';
import modalAdAssessmentCtrl from '../../blocks/modals/modal-ad-assessment/modal-ad-assessment.controller';
import modalHintCtrl from '../../blocks/modals/modal-hint/modal-hint.controller';
import modalHintTemplate from '../../blocks/modals/modal-hint/modal-hint.jade';
import modalPayByCardCtrl from '../../blocks/modals/modal-pay-by-card/pay-by-card.controller';
import modalPremoderationConfirmCtrl from '../../blocks/modals/modal-premoderation-confirm/modal-premoderation-confirm.controller';
import modalReportAddressCtrl from '../../blocks/modals/modal-report-address/modal-report-address.controller';
import modalReportErrorCtrl from '../../blocks/modals/modal-report-error/modal-report-error.controller';
import modalReportFormCtrl from '../../blocks/modals/modal-report-form/modal-report-form.controller';
import modalReportMessageErrorCtrl from '../../blocks/modals/modal-report-message-error/modal-report-message-error.controller';
import modalReportMessageErrorTemplate from '../../blocks/modals/modal-report-message-error/modal-report-message-error.jade';
import modalReportMessageOkCtrl from '../../blocks/modals/modal-report-message-ok/modal-report-message-ok.controller';
import modalReportMessageOkTemplate from '../../blocks/modals/modal-report-message-ok/modal-report-message-ok.jade';
import multiPostingConfirmCtrl from '../../blocks/modals/modal-multiposting-confirm/modal-multiposting-confirm.controller';
import multiPostingConfirmTemplate from '../../blocks/modals/modal-multiposting-confirm/modal-multiposting-confirm.jade';
import payByCardTemplate from '../../blocks/modals/modal-pay-by-card/pay-by-card.jade';
import premoderationConfirmTemplate from '../../blocks/modals/modal-premoderation-confirm/modal-premoderation-confirm.jade';
import pubAvailCtrl from '../../blocks/modals/modal-pub-avail/modal-pub-avail.controller';
import pubAvailTemplate from '../../blocks/modals/modal-pub-avail/modal-pub-avail.jade';
import refillAgencyBalanceCtrl from '../../blocks/modals/modal-refill-agency-balance/refill-agency-balance.controller';
import refillAgencyBalanceTemplate from '../../blocks/modals/modal-refill-agency-balance/modal-refill-agency-balance.jade';
import refillBalanceCtrl from '../../blocks/modals/modal-refill-balance/refill-balance.controller';
import refillBalanceTemplate from '../../blocks/modals/modal-refill-balance/modal-refill-balance.jade';
import reportAddressTemplate from '../../blocks/modals/modal-report-address/modal-report-address.jade';
import reportCheckPublishErrorTemplate from '../../blocks/modals/modal-report-check-publish-error/modal-report-check-publish-error.jade';
import reportErrorTemplate from '../../blocks/modals/modal-report-error/modal-report-error.jade';
import reportFormTemplate from '../../blocks/modals/modal-report-form/modal-report-form.jade';
import rulesTemplate from '../../blocks/modals/modal-rules/modal-rules.jade';
import serverErrorModalTemplate from '../../blocks/modals/modal-server-error/modal-server-error.jade';
import upsaleHighlightCtrl from '../../blocks/modals/modal-upsale-highlight/modal-upsale-highlight.controller';
import upsaleHighlightFailureTemplate from '../../blocks/modals/modal-upsale-highlight-failure/modal-upsale-highlight-failure.jade';
import upsaleHighlightSuccessTemplate from '../../blocks/modals/modal-upsale-highlight-success/modal-upsale-highlight-success.jade';
import upsaleHighlightTemplate from '../../blocks/modals/modal-upsale-highlight/modal-upsale-highlight.jade';
import validationErrorCtrl from '../../blocks/modals/modal-validation-error/modal-validation-error.controller';
import validationErrorTemplate from '../../blocks/modals/modal-validation-error/modal-validation-error.jade';

app.factory('popupService', [
  '$uibModal',
  'deviceService',
  '$document',
  ($uibModal, deviceService, $document) => {
    const modals = {
      hint: {
        template: modalHintTemplate,
        controller: modalHintCtrl,
        controllerAs: 'modalHint',
      },
      reportMessageOk: {
        template: modalReportMessageOkTemplate,
        controller: modalReportMessageOkCtrl,
        controllerAs: 'modalReportMessageOk',
      },
      reportMessageError: {
        template: modalReportMessageErrorTemplate,
        controller: modalReportMessageErrorCtrl,
        controllerAs: 'modalReportMessageError',
      },
      adAssessment: {
        template: adAssessmentTemplate,
        controller: modalAdAssessmentCtrl,
        controllerAs: 'modalAdAssessmentCtrl',
      },
      reportForm: {
        template: reportFormTemplate,
        controller: modalReportFormCtrl,
        controllerAs: 'modalReportFormCtrl',
      },
      reportError: {
        template: reportErrorTemplate,
        controller: modalReportErrorCtrl,
        controllerAs: 'modalReportErrorCtrl',
      },
      reportAddress: {
        template: reportAddressTemplate,
        controller: modalReportAddressCtrl,
        controllerAs: 'modalReportAddressCtrl',
      },
      adRules: {
        template: rulesTemplate,
      },
      pubAvail: {
        template: pubAvailTemplate,
        controller: pubAvailCtrl,
        controllerAs: 'pubAvailCtrl',
      },
      jkAdd: {
        template: jkAddTemplate,
        controller: jkAddCtrl,
        controllerAs: 'jkAddCtrl',
      },
      serverError: {
        template: serverErrorModalTemplate,
      },
      refillBalance: {
        template: refillBalanceTemplate,
        controller: refillBalanceCtrl,
        controllerAs: 'refillBalanceCtrl',
      },
      refillAgencyBalance: {
        template: refillAgencyBalanceTemplate,
        controller: refillAgencyBalanceCtrl,
        controllerAs: '$ctrl',
      },
      validationError: {
        template: validationErrorTemplate,
        controller: validationErrorCtrl,
        controllerAs: 'validationErrorCtrl',
      },
      identification: {
        template: identificationTemplate,
        controller: identificationCtrl,
        controllerAs: 'identificationCtrl',
      },
      // При попытке идентификации по паспорту произошла ошибка
      identificationError: {
        template: identificationErrorTemplate,
        controller: identificationErrorCtrl,
        controllerAs: 'identificationErrorCtrl',
      },
      // Подтверждение включения/выключения активного черновика
      activeDraft: {
        template: activeDraftTemplate,
        controller: activeDraftCtrl,
        controllerAs: 'activeDraft',
      },
      // Покупка ВЦ на странице успеха
      upsaleHighlight: {
        template: upsaleHighlightTemplate,
        controller: upsaleHighlightCtrl,
        controllerAs: 'upsaleHighlightCtrl',
      },
      upsaleHighlightSuccess: {
        template: upsaleHighlightSuccessTemplate,
      },
      upsaleHighlightFailure: {
        template: upsaleHighlightFailureTemplate,
      },
      checkPublishError: {
        template: reportCheckPublishErrorTemplate,
      },
      authError: {
        template: authErrorTemplate,
        controller: authErrorCtrl,
        controllerAs: 'authError',
      },
      payByCard: {
        template: payByCardTemplate,
        controller: modalPayByCardCtrl,
        controllerAs: 'modalPayByCardCtrl',
      },
      premoderationConfirm: {
        template: premoderationConfirmTemplate,
        controller: modalPremoderationConfirmCtrl,
        controllerAs: 'modalPremoderationConfirmCtrl',
      },
      advertiseObject: {
        template: advertiseObjectTemplate,
        controller: advertiseObjectCtrl,
        controllerAs: 'advertiseObjectCtrl',
      },
      ivrRemind: {
        template: ivrRemindTemplate,
        controller: ivrRemindCtrl,
        controllerAs: 'ivrRemind',
      },
      auctionConfirm: {
        template: auctionConfirmTemplate,
        controller: auctionConfirmCtrl,
        controllerAs: 'auctionConfirmCtrl',
      },
      auctionAdd: {
        template: auctionAddTemplate,
        controller: auctionAddCtrl,
        controllerAs: 'auctionAddCtrl',
      },
      auctionIncrease: {
        template: auctionIncreaseTemplate,
        controller: auctionIncreaseCtrl,
        controllerAs: 'auctionIncreaseCtrl',
      },
      homeownerHint: {
        template: homeownerHintTemplate,
      },
      fullscreenPlanPreview: {
        template: fullscreenPlanPreviewTemplate,
        controller: fullscreenPlanPreviewCtrl,
        controllerAs: 'fullscreenPlanPreviewCtrl',
      },
      PackageBuyConfirmationModal: {
        template: PackageBuyConfirmationModalTemplate,
        controller: PackageBuyConfirmationModalController,
        controllerAs: 'PackageBuyConfirmationModalCtrl',
      },
      PackageBuyResultModal: {
        template: PackageBuyResultModalTemplate,
        controller: PackageBuyResultModalController,
        controllerAs: 'PackageBuyResultModalCtrl',
      },
      multiPostingConfirm: {
        template: multiPostingConfirmTemplate,
        controller: multiPostingConfirmCtrl,
        controllerAs: 'multiPostingConfirmCtrl',
      },
    };

    const { isMobile } = deviceService;

    const openPopup = (name, data = {}) => {
      const modal = modals[name];

      if (modal && !modal.opened) {
        // только один открытый попап одного типа в момент времени
        modal.opened = true;
        // Преобразуем объекты в функции, чтобы использовать их в resolve
        Object.keys(data).forEach(key => {
          const value = data[key];
          data[key] = () => value;
        });

        const modalWrapper = document.querySelector('.modal-wrapper');
        const $modalWrapper = angular.element(modalWrapper);

        const mobileModalConfig = isMobile && {
          appendTo: $modalWrapper,
          openedClass: 'modal-open',
        };

        const modalInstance = $uibModal.open({
          ...modal,
          resolve: {
            ...data,
          },
          ...mobileModalConfig,
        });

        if (isMobile) {
          $modalWrapper.addClass('modal-open');
          $document.find('body').addClass('modal-body-wrapper');
        }

        if (angular.isFunction(modal.onOpened)) {
          modalInstance.opened.then(modal.onOpened);
        }

        if (angular.isFunction(modal.onClosed)) {
          modalInstance.closed.then(modal.onClosed);
        }

        modalInstance.closed.finally(() => {
          modal.opened = false;

          if (isMobile) {
            $modalWrapper.removeClass('modal-open');
            $document.find('body').removeClass('modal-body-wrapper');
          }
        });

        return modalInstance;
      }
    };

    const isOpen = name => {
      return modals[name].opened;
    };

    listenEvent(OPEN_MODAL, ({ name, data }) => {
      openPopup(name, data);
    });

    return {
      openPopup,
      isOpen,
    };
  },
]);
